import { ReactElement } from "react";

import { UiImageSetModel, UiImageModel } from "../../models";
import { renderViewModel } from "../../render-view-model";

import { List } from "./UiImageSet.styles";

export type UiImageSetProps = {
    readonly model: UiImageSetModel;
};

const UiImageSet = ({
    model: {
        content: { images, justified }
    }
}: UiImageSetProps): ReactElement => {
    return (
        <List justified={justified}>
            {images.map((image: UiImageModel, index: number) => (
                <li key={`${image.id}_${index}`}>{renderViewModel(image)}</li>
            ))}
        </List>
    );
};

export default UiImageSet;
